/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionlanguages2Inputs */

const en_eventdescriptionlanguages2 = /** @type {(inputs: Eventdescriptionlanguages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const de_eventdescriptionlanguages2 = /** @type {(inputs: Eventdescriptionlanguages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Eventdescriptionlanguages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionlanguages2 = /** @type {((inputs?: Eventdescriptionlanguages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionlanguages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionlanguages2(inputs)
	return de_eventdescriptionlanguages2(inputs)
});
export { eventdescriptionlanguages2 as "eventDescriptionLanguages" }